import { API } from 'service/API'

import { ILegalEntityJSON, ILegalEntityResJSON } from './LegalEntitiesModel'

export class LegalEntitiesService {
  API: API

  constructor(api: API) {
    this.API = api
  }

  getAll = (): Promise<ILegalEntityResJSON> => {
    return this.API.network.legalEntities.getLegalEntities()
  }

  findByIds = async (_ids: string[]): Promise<ILegalEntityJSON[]> => {
    if (!_ids.length) {
      return Promise.resolve([])
    }

    const pagedResponse = await this.API.network.legalEntities.getManyLegalEntity(_ids.join(','))
    return pagedResponse.data
  }

  search = (searchText: string): Promise<ILegalEntityResJSON> => {
    return this.API.network.legalEntities.searchLegalEntity(searchText)
  }

  save = (legalEntity: Partial<ILegalEntityJSON>): Promise<ILegalEntityJSON> => {
    return this.API.network.legalEntities.saveLegalEntity(legalEntity)
  }
}
